<template>
  <svg viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 0.25C1.12109 0.25 0 1.37109 0 2.75V4H22.5V2.75C22.5 1.37109 21.3789 0.25 20 0.25H2.5ZM22.5 7.75H0V15.25C0 16.6289 1.12109 17.75 2.5 17.75H20C21.3789 17.75 22.5 16.6289 22.5 15.25V7.75ZM4.375 12.75H6.875C7.21875 12.75 7.5 13.0312 7.5 13.375C7.5 13.7188 7.21875 14 6.875 14H4.375C4.03125 14 3.75 13.7188 3.75 13.375C3.75 13.0312 4.03125 12.75 4.375 12.75ZM8.75 13.375C8.75 13.0312 9.03125 12.75 9.375 12.75H14.375C14.7188 12.75 15 13.0312 15 13.375C15 13.7188 14.7188 14 14.375 14H9.375C9.03125 14 8.75 13.7188 8.75 13.375Z"
      fill="white"
    />
  </svg>
</template>
